import { isBefore, addDays } from 'date-fns';



export function findFurthestEndDate(payloadDate: Date, end_date: Date): Date {
    const maxAllowedDate = addDays(payloadDate, 8);

    return isBefore(maxAllowedDate, end_date) ? maxAllowedDate : end_date;
}
export function findNearestStartDate(maxDate: Date, start_date: Date): Date {
    const minAllowedDate = addDays(maxDate, -8);

    return isBefore(start_date, minAllowedDate) ? minAllowedDate : start_date;
}
